import React from 'react'
import ReactDOM from 'react-dom'
// https://github.com/coderiety/react-list
import ReactList from 'react-list';

import { __ } from 'StylistParent/i18n';
import IconButton from 'Components/icon-button';

import * as systemFonts from './systemfonts.json'
// https://developers.google.com/fonts/docs/developer_api
import * as googleFonts from './googlefonts.json'


class FontItems extends React.Component {
	constructor( props ) {
		super( props )
		this.fonts = this.getFonts()
		this.fontPreviewPhrases = this.fontPreviewPhrases()
	}

	getFonts = () => {
		// Fixes error "If you meant to render a collection of children, use an array instead."
		// const arr = Object.values( googleFonts.items ); // Google Fonts
		const arr = Object.values( systemFonts.items );
		return arr
	}

	/**
	 * Determine if provided objec is description from Google Fonts API.
	 * Object should have 'files' property with links to the google server.
	 * Example:
	 *  "files": {
	 *    "700": "http://fonts.gstatic.com/s/...
	 *   }
	 */

	isGoogleFont = ( font ) => {
		let response = false
		if ( "files" in font && font.files[Object.keys(font.files)[0]].includes('gstatic.com') ) {
			response = true
		}
		return response
	}

	fontPreviewPhrases = () => {
		return [
			'All their equipment and instruments are alive.',
			'A red flair silhouetted the jagged edge of a wing.',
			'I watched the storm, so beautiful yet terrific.',
			'Almost before we knew it, we had left the ground.',
			'A shining crescent far beneath the flying vessel.',
			'It was going to be a lonely trip back.',
			'Mist enveloped the ship three hours out from port.',
			'My two natures had memory in common.',
			'Silver mist suffused the deck of the ship.',
			'The face of the moon was in shadow.',
			'She stared through the window at the stars.',
			'The recorded voice scratched in the speaker.',
			'The sky was cloudless and of a deep dark blue.',
			'The spectacle before us was indeed sublime.',
			'Then came the night of the first falling star.',
			'Waves flung themselves at the blue evening.'
		]
	}

	renderItem = ( index, key ) => {
		const fontFamilyURL = this.fonts[ index ].family.replace( ' ', '+' )
		let fontSuffix = ''

		// Check if font has 'regular' variant?
		if ( this.fonts[ index ].variants.indexOf( 'regular' ) === -1 ) {
			// If no 'regular' try '300'.
			if ( this.fonts[ index ].variants.indexOf( '300' ) > -1 ) {
				fontSuffix = ':300'
			} else if ( this.fonts[ index ].variants.indexOf( '500' ) > -1 ) {
				fontSuffix = ':500'
			} else if ( this.fonts[ index ].variants.indexOf( '100' ) > -1 ) {
				fontSuffix = ':100'
			} else if ( this.fonts[ index ].variants.indexOf( '600' ) > -1 ) {
				fontSuffix = ':600'
			}
		}

		const previewPhraseId = index % this.fontPreviewPhrases.length;

		return <div id={ 'font-render-' + key }
			key={key}
			className="stlst-font-render"
			onClick = { () => {
				this.props.onFontSelected( this.fonts[ index ] )
			} } >
			<h2 className="font-title">{ this.fonts[ index ].family }</h2>
			<p className="font-preview" style={ { fontFamily: this.fonts[ index ].family } }>{ this.fontPreviewPhrases[ previewPhraseId ] }</p>
			{ /* Change to load this link in the body so it stays for whole session */}
			{ this.isGoogleFont( this.fonts[ index ] ) && <link href={ "https://fonts.googleapis.com/css?family=" + fontFamilyURL + fontSuffix } rel="stylesheet" />  }
		</div>
	}

	render() {
		const popupRoot = document.getElementById( 'popup-root' );

		return ReactDOM.createPortal(
			<div className="stlst-font-picker">
				<div className="stlst-font-picker-header">
					<IconButton
						className="stlst-font-picker-close"
						onClick={ this.props.toggleFontSelector }
						icon="no-alt-2"
						label={ __( 'Close' ) }
					/>
				</div>
				<div className="stlst-fonts">
					<ReactList
						// Renders only part of the very large set
						// for better performance (Lazy Loading).
						itemRenderer={this.renderItem}
						length={this.fonts.length}
						type="uniform"
						threshold={400}
						// Pre-loading threshold in px (top and bottom)
						// need it here to give Google fonts enought time for loading.
					/>
				</div>
			</div>,
			popupRoot,
		);
	}
}

export default FontItems;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/font-selector/font-items.jsx